// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__MX8fA","message":"styles_message__1IVlw","actions":"styles_actions__3knZ0"};